<template>
    <div>
        <button
            ref="triggerButton"
            type="button"
            class="btn btn-primary d-none"
            data-bs-toggle="modal"
            :data-bs-target="`#${modalId}`"
        ></button>
        <div class="modal fade support-jm-modal" :id="modalId" tabindex="-1" aria-hidden="true"
            data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-lg modal-dialog-centered support-modal-dialog">
                <div class="modal-content" style="background-color: rgba(60,60,60,.95);">
                    <div class="modal-header2 p-0">
                        <h6 class="modal-title">
                            Contactar a Mesa de ayuda
                            <button
                                ref="closeButton"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                style="background:transparent;float:right;color:white"
                            >
                                <i class="fas fa-times"></i>
                            </button>
                        </h6>
                    </div>
                    <div class="modal-body support-modal-body p-4">
                        <input v-model="supportForm.subject" type="text" class="support-input" placeholder="Asunto" />
                        <div class="support-message-wrapper">
                            <button type="button" class="support-file-btn" @click="triggerSupportFilePicker">
                                <i class="fas fa-paperclip"></i>
                            </button>
                            <textarea
                                v-model="supportForm.message"
                                class="support-textarea"
                                placeholder="Ingrese aqui el mensaje"
                            ></textarea>
                        </div>
                        <input ref="supportFileInput" type="file" class="d-none" multiple @change="onSupportFilesSelected" />
                        <div v-if="supportFiles.length" class="mt-2 text-white" style="font-size:12px;">
                            {{ supportFiles.join(', ') }}
                        </div>
                        <div class="support-actions">
                            <button class="support-btn secondary" data-bs-dismiss="modal">CANCELAR</button>
                            <button class="support-btn primary" @click="sendSupportTicket">ENVIAR</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "supportJmModal",
    props: {
        modalId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            supportForm: {
                subject: '',
                message: ''
            },
            supportFiles: []
        }
    },
    methods: {
        open(payload) {
            if (payload === 'newMessage') {
                this.supportForm.subject = '';
                this.supportForm.message = '';
                this.supportFiles = [];
            } else if (payload && typeof payload === 'object') {
                this.supportForm.subject = `Ticket #${payload.id}`;
                this.supportForm.message = payload.mensaje || '';
                this.supportFiles = [];
            }

            this.$refs.triggerButton?.click();
        },
        triggerSupportFilePicker() {
            this.$refs.supportFileInput?.click();
        },
        onSupportFilesSelected(event) {
            const files = Array.from(event.target.files || []);
            this.supportFiles = files.map(file => file.name);
        },
        sendSupportTicket() {
            if (!this.supportForm.subject || !this.supportForm.message) return;
            this.$refs.closeButton?.click();
        }
    }
}
</script>

<style scoped>
.support-modal-dialog {
    width: min(500px, calc(100vw - 24px));
    max-width: 500px;
    min-height: 100vh;
    display: flex;
    align-items: center;
}

.support-modal-dialog .modal-content {
    height: 413.42px;
}

.modal-header2 {
    margin-left: 5% !important;
    margin-right: 5% !important;
    margin-top: -1.25rem !important;
    margin-bottom: 0 !important;
    height: 60px;
    padding: 1rem !important;
    color: #fff;
    border-bottom: none;
    background: linear-gradient(40deg, #292d3d, #03040d) !important;
    display: flex;
    align-items: center;
}

.modal-title {
    font-family: "Metropolis", sans-serif;
    font-weight: 600;
    font-size: 16px;
    width: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.btn-close {
    color: #fff !important;
    opacity: 1;
    margin-left: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-close i {
    color: #fff !important;
}

.modal-body {
 padding: 24px 24px 8px 24px !important;

}

.support-modal-body {
    height: calc(413.42px - 60px);
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.support-message-wrapper {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-top: 60px;
}

.support-file-btn {
    width: 50px;
    height: 50px;    
    border-radius: 50%;
    border: 0;
    color: #fff;
    background: #292D3D;
    flex: 0 0 auto;
    margin-top: 8px;
}

.support-file-btn i {
  font-size: 2rem;
}

.support-input,
.support-textarea {
    font-family: "Metropolis", sans-serif;  
    width: 100%;
    border: 0;
    border-radius: 10px;
    padding: 14px 16px;
    font-size: 16px;
    color: #222;
    
}

.support-input::placeholder, .support-textarea::placeholder {
    font-weight: 500;
    font-size: 12px;
    padding-bottom: 12px;
}

.support-input {
    margin-top: 20px;
    margin-left: 66px;
    width: calc(100% - 66px);
}

.support-textarea {
    height: 105.56px;
    min-height: 105.56px;
    resize: vertical;
}

.support-actions {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-top: auto;
    padding-top: 22px;
    padding-bottom: 8px;
}

.support-btn {
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);
    font-size: 13px;
    font-family: "Metropolis", sans-serif;
    font-weight: 500;
    padding: 14px 16px;
    color: #fff;
    background: #1f2742;
}

.support-btn.secondary,
.support-btn.primary {
    border-radius: 999px;
    background: #292D3D;
}

@media (max-width: 767px) {
    .support-file-btn i {
        font-size: 1.2rem;
    }
}




</style>
